var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"className":"m-vue-pdf"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}]},_vm._l((_vm.numPages),function(index){return _c('Pdf',{key:index,attrs:{"src":_vm.pdfUrl1,"page":index}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }